import { useLegends } from 'presentation/app/hooks/useLegends';
import { TableColumn } from 'react-data-table-component';

import Badge from '../../../components/badgeComponent';
import { IActivitiesTabs } from '../../../models/activities-tabs';

export const makeColumnsCompleted = (): TableColumn<IActivitiesTabs>[] => {
  const { getLegends } = useLegends();
  return [
    {
      name: `${getLegends('ESTUDANTE', true)}`,
      sortable: false,
      wrap: true,
      width: '200px',
      cell: (row) => {
        return (
          <div className="d-flex align-items-center">
            <div className="me-3">
              <img
                src={
                  row.foto ||
                  'data:image/jpeg;base64,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'
                }
                alt="Avatar"
                style={{ width: '30px', height: '30px', borderRadius: '50%' }}
              />
            </div>
            <div>
              <span>{row.nome}</span>
            </div>
          </div>
        );
      },
    },
    {
      name: 'Tarefa',
      selector: (row) => row.tarefa,
      sortable: false,
    },
    {
      name: 'Local',
      selector: (row) => row.local_stage,
      sortable: false,
      wrap: true,
    },
    {
      name: `${getLegends('GRUPO', false)}`,
      selector: (row) => row.grupo,
      sortable: false,
      wrap: true,
    },
    {
      name: 'Início',
      selector: (row) => row.inicio,
      sortable: false,
    },
    {
      name: '',
      selector: (row) => row.detalhes,
      sortable: false,
      width: '200px',
      cell: (row) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <div className="me-3 d-flex">
                <Badge
                  iconClass="ri-alarm-line"
                  condition={row?.starts?.onTime}
                />
                <Badge
                  iconClass="ri-map-pin-line"
                  condition={row?.starts?.onPlace}
                  title={
                    row?.starts?.onPlace === false &&
                    `Distante ${row.starts.distance}`
                  }
                />
                {row?.starts?.isOffline && (
                  <span className={`badge rounded-pill bg-dark`}>
                    <i className={`ri-wifi-off-line fs-6 p-1`}></i>
                  </span>
                )}
              </div>
            </div>
          </>
        );
      },
    },
    {
      name: 'Término',
      selector: (row) => row.termino,
      sortable: false,
    },
    {
      name: '',
      selector: (row) => row.detalhes,
      sortable: false,
      width: '200px',
      cell: (row) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <div className="me-3 d-flex">
                <Badge
                  iconClass="ri-alarm-line"
                  condition={row?.ends?.onTime}
                />
                <Badge
                  iconClass="ri-map-pin-line"
                  condition={row?.ends?.onPlace}
                  title={
                    row?.ends?.onPlace === false &&
                    `Distante ${row.ends.distance}`
                  }
                />
                {row?.starts?.isOffline && (
                  <span className={`badge rounded-pill bg-dark`}>
                    <i className={`ri-wifi-off-line fs-6 p-1`}></i>
                  </span>
                )}
              </div>
            </div>
          </>
        );
      },
    },
  ];
};
